import { NextPage } from 'next';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import LoadingStoreCard from '../../components/Shimmer/LoadingStoresCards';

import { Title, StoreCard, Button } from '../../components/UI';
import { useHome } from '../../hooks/home';
import { AdvertiserListItem } from '../../models/home';

import {
  Container,
  StoreCards,
  AlignButton,
} from '../../styles/pages/stores/styles';

const Stores: NextPage = () => {
  const [stores, setStores] = useState<AdvertiserListItem[]>([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingStore, setIsLoadingStore] = useState<number>();
  const [enableShowMore, setEnableShowMore] = useState(false);

  const { getAdvertisers } = useHome();
  const router = useRouter();
  const { tag } = router.query;

  useEffect(() => {
    async function getInitialData() {
      try {
        const storesData = await getAdvertisers(20, page, tag as string);
        if (storesData.length >= 20) {
          setEnableShowMore(true);
        }
        setStores(storesData);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }

    getInitialData();
  }, []);

  const handleShowMore = async () => {
    try {
      setIsLoading(true);
      const storesData = await getAdvertisers(20, page + 1, tag as string);
      if (storesData.length < 20) {
        setEnableShowMore(false);
      }
      setStores([...stores, ...storesData]);
      setPage(page + 1);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleStoreClick = (slug: string) => {
    router.push({
      pathname: `store/${slug}`,
    });
  };

  return (
    <Container>
      <Title>Todas as Lojas</Title>
      <StoreCards>
        {stores.map((store, index) => (
          <button
            key={index}
            onClick={() => {
              setIsLoadingStore(index), handleStoreClick(store.slug);
            }}
            className="storecard"
          >
            <StoreCard.Default
              key={index}
              store={store}
              title={store.name}
              loading={isLoadingStore === index}
            />
          </button>
        ))}
        {isLoading &&
          [...Array(20)].map((item, index) => (
            <StoreCards>
              <LoadingStoreCard key={index} />
            </StoreCards>
          ))}
      </StoreCards>
      {enableShowMore && (
        <AlignButton>
          <Button className="showMore" onClick={handleShowMore}>
            Ver Mais
          </Button>
        </AlignButton>
      )}
    </Container>
  );
};

Stores.getInitialProps = async ({ query }) => {
  const { tag } = query;
  return { tag };
};

export default Stores;
